import GamesByCategory from "pages/home/GamesByCategory";

// ICONS GAME CATEGORY
import IconSlots from "assets/icons/icon-slots.svg";
import IconCrash from "assets/icons/icon-crash.svg";
import ProfileDetail from "pages/user-settings/my-profile/ProfileDetail";
import ChangePassword from "pages/user-settings/my-profile/ChangePassword";
import VerifyAccount from "pages/user-settings/my-profile/VerifyAccount";
import TwoStepAuthentication from "pages/user-settings/my-profile/TwoStepAuthentication";
import TimeOut from "pages/user-settings/my-profile/TimeOut";
import BetHistory from "pages/user-settings/bet-history/BetHistory";
import SportsBonuses from "pages/user-settings/bonuses/SportsBonuses";
import CasinoBonus from "pages/user-settings/bonuses/CasinoBonus";
import CasinoFreeSpins from "pages/user-settings/bonuses/CasinoFreeSpins";
import BonusHistory from "pages/user-settings/bonuses/BonusHistory";
import ReferAFriend from "pages/user-settings/bonuses/ReferAFriend";
import PromoCode from "pages/user-settings/bonuses/PromoCode";
import TransactionHistory from "pages/user-settings/balance-management/TransactionHistory";
import WithdrawStatus from "pages/user-settings/balance-management/WithdrawStatus";
import Deposit from "pages/user-settings/balance-management/deposit-withdraw/Deposit";
import Withdraw from "pages/user-settings/balance-management/deposit-withdraw/Withdraw";

// ICONS - ADMIN NAVIGATION
import { ReactComponent as IconTransfer } from "../assets/icons/icon-transfer.svg";
import { ReactComponent as IconTransferHistory } from "../assets/icons/icon-transfer-history.svg";
import { ReactComponent as IconTransferReport } from "../assets/icons/icon-transfer-report.svg";
import { ReactComponent as IconGamingReport } from "../assets/icons/icon-gaming-report.svg";
import { ReactComponent as IconSportbookBets } from "../assets/icons/icon-sportsbook-bets.svg";
import { ReactComponent as IconCasinoBets } from "../assets/icons/icon-casino-bets.svg";
import { ReactComponent as IconManageUsers } from "../assets/icons/icon-manage-users.svg";
import { ReactComponent as IconRegisterUser } from "../assets/icons/icon-register-user.svg";
// PAGES - ADMIN NAVIGATION
import TransferForm from "pages/admin/transfer/TransferForm";
import TransferHistory from "pages/admin/transfer/TransferHistory";
import TransferReport from "pages/admin/transfer/TransferReport";
import GamingReport from "pages/admin/GamingReport";
import CasinoBets from "pages/admin/CasinoBet";
import ManageUser from "pages/admin/ManageUser";
import RegisterForm from "pages/admin/RegisterUser";
import SportBetBook from "pages/admin/SportBetBook";
import { useTranslation } from "react-i18next";
import OnlineUser from "pages/admin/OnlineUser";

export const APP_NAV = () => {
  const { t } = useTranslation();
  return [
    {
      label: t("Live"),
      path: "/sportsbook/live",
      iconHeader: <i className="bc-i-live" />,
      iconAppbarMenu: <i className="bc-i-live  bg-primary" />,
    },
    {
      label: t("Sports"),
      path: "/sportsbook/sports",
      iconHeader: <i className="bc-i-prematch" />,
      iconAppbarMenu: <i className="bc-i-prematch bg-[#6585a1]" />,
    },
    {
      label: t("Casino"),
      path: "/casino/all/asc",
      iconHeader: <i className="bc-i-BestNetentSlots" />,
      iconAppbarMenu: <i className="bc-i-casino bg-[#6585a1]" />,
    },
    {
      label: t("Live Casino"),
      path: "/live-casino/all/asc",
      iconHeader: <i className="bc-i-live-casino" />,
      iconAppbarMenu: <i className="bc-i-live-casino bg-[#1967f5]" />,
    },
    {
      label: t("Mini Games"),
      path: "/mini-games/all/asc",
      iconHeader: <i className="bc-i-games" />,
      iconAppbarMenu: <i className="bc-i-games bg-[#19f52b]" />,
    },
    {
      label: t("Promotions"),
      path: "/promotions",
      iconHeader: <i className="bc-i-promotion" />,
      iconAppbarMenu: <i className="bc-i-promotion bg-[#f7ff2b]" />,
    },
  ];
};

export const ADMIN_NAV = () => {
  const { t } = useTranslation();
  return [
    {
      index: true,
      title: t("Transfer"),
      path: "/transfer",
      component: <TransferForm />,
      image: <IconTransfer />,
    },
    {
      title: t("Transfer History"),
      path: "/transfer-history",
      component: <TransferHistory />,
      image: <IconTransferHistory />,
    },
    {
      title: t("Transfers Report"),
      path: "/transfers-report",
      component: <TransferReport />,
      image: <IconTransferReport />,
    },
    {
      title: t("Gaming Report"),
      path: "/gaming-report",
      component: <GamingReport />,
      image: <IconGamingReport />,
    },
    {
      title: t("Sportsbook Bets"),
      path: "/sportsbook-bets",
      component: <SportBetBook />,
      image: <IconSportbookBets />,
    },
    {
      title: t("Casino Bets"),
      path: "/casino-bets",
      component: <CasinoBets />,
      image: <IconCasinoBets />,
    },
    {
      title: t("Manage Users"),
      path: "/manage-users",
      component: <ManageUser />,
      image: <IconManageUsers />,
    },
    {
      title: t("Online Users"),
      path: "/online-users",
      component: <OnlineUser />,
      image: <IconManageUsers />,
    },
    {
      title: t("Register User"),
      path: "/register-user",
      component: <RegisterForm />,
      image: <IconRegisterUser />,
    },
  ];
};

export const APPBAR_NAV = () => {
  const { t } = useTranslation();
  return [
    {
      label: t("Live"),
      path: "/sportsbook/live",
      iconHeader: <i className="bc-i-live" />,
      icon: <i className="bc-i-live text-[24px]" />,
    },
    {
      label: t("Sports"),
      path: "/sportsbook/sports",
      iconHeader: <i className="bc-i-prematch" />,
      icon: <i className="bc-i-prematch text-[24px]" />,
    },
    {
      label: t("Casino"),
      path: "/casino/all/asc",
      icon: <i className="bc-i-slots text-[24px]" />,
    },
    {
      label: t("Live Casino"),
      path: "/live-casino/all/asc",
      iconHeader: <i className="bc-i-live-casino" />,
      icon: <i className="bc-i-live-casino text-[24px]" />,
    },
  ];
};

export const APP_FOOTER_NAV = [
  {
    title: "ABOUT",
    links: [
      { label: "About us", link: "about-us" },
      { label: "Careers", link: "careers" },
      { label: "Affiliation", link: "affiliation" },
    ],
  },
  {
    title: "HELP",
    links: [
      { label: "Responsible Gaming", link: "responsible-gaming" },
      { label: "FAQ", link: "faq" },
      { label: "Contact us", link: "contact-us" },
    ],
  },
  {
    title: "REGULATIONS",
    links: [
      {
        label: "General Terms and Conditions",
        link: "general-terms-and-conditions",
      },
      { label: "Privacy Policy", link: "privacy-policy" },
    ],
  },
  {
    title: "GAMING RULES",
    links: [
      { label: "Sportsbook", link: "sportsbook" },
      { label: "Bet Builder", link: "bet-builder" },
      { label: "Casino", link: "/casino/all/asc" },
      { label: "Poker", link: "poker" },
      { label: "Backgammon", link: "backgammon" },
    ],
  },
  {
    title: "STATISTICS",
    links: [
      { label: "Stats", link: "stats" },
      { label: "Results", link: "results" },
    ],
  },
  {
    title: "FTN",
    links: [{ label: "FTN", link: "ftn" }],
  },
];

export const GAMES_BY_CATEGORY = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("Casino"),
      path: "/casino/all/asc",
      icon: <i className="bc-i-live" />,
      component: <GamesByCategory />,
      category: "pragmatic play",
    },
    {
      title: t("Live Casino"),
      path: "/live-casino/all/asc",
      icon: <i className="bc-i-live" />,
      component: <GamesByCategory />,
      type: "livecasino",
    },
    {
      title: t("Games"),
      path: "/mini-games/all/asc",
      icon: <i className="bc-i-live" />,
      component: <GamesByCategory />,
      type: "crash-games",
    },
  ];
};

export const GAMES_CATEGORY_NAV = () => {
  const { t } = useTranslation();
  return {
    CASINO: [
      {
        label: t("All Games"),
        path: "/all",
        category: "",
        icon: <i className="bc-i-all-games" />,
      },
      {
        label: t("Slots"),
        path: "/slots",
        category: "video-slots",
        icon: IconSlots,
      },
      {
        label: t("Crash"),
        path: "/crash",
        category: "crash-games",
        icon: IconCrash,
      },
    ],
    LIVE_CASINO: [
      {
        label: t("All Games"),
        path: "/all",
        category: "",
        icon: <i className="bc-i-all-games" />,
      },
      {
        label: "Blackjack",
        path: "/black-jack",
        category: "",
        icon: <i className="bc-i-blackjack" />,
      },
      {
        label: t("Roulette"),
        path: "/roulette",
        category: "",
        icon: <i className="bc-i-roulette" />,
      },
      {
        label: t("Asian Games"),
        path: "/asian-games",
        category: "",
        icon: <i className="bc-i-asianGames" />,
      },
      {
        label: t("Poker"),
        path: "/poker",
        category: "",
        icon: <i className="bc-i-poker" />,
      },
    ],
  };
};

export const USER_ACTIONS_NAV = () => {
  const { t } = useTranslation();
  return [
    {
      key: "myProfile",
      label: t("My Profile"),
      icon: "bc-i-user",
      child: [
        {
          parentKey: "myProfile",
          key: "myProfile",
          label: t("Profile Details"),
          component: <ProfileDetail />,
        },
        {
          parentKey: "myProfile",
          key: "changePassword",
          label: t("Change Password"),
          component: <ChangePassword />,
        },
        {
          parentKey: "myProfile",
          key: "verifyAccount",
          label: t("Verify Account"),
          component: <VerifyAccount />,
        },

        {
          parentKey: "myProfile",
          key: "timeOut",
          label: t("Time-Out"),
          component: <TimeOut />,
        },
        {
          parentKey: "myProfile",
          key: "twoStepAuthentication",
          label: t("Tow-Step Authentication"),
          component: <TwoStepAuthentication />,
        },
      ],
    },
    {
      key: "betHistory",
      label: t("Bet History"),
      icon: "bc-i-history",
      child: [
        {
          parentKey: "betHistory",
          key: "betHistory",
          label: t("All"),
          component: <BetHistory />,
        },
        {
          parentKey: "betHistory",
          key: "betHistoryOpenBets",
          label: t("Open Bets"),
          component: <BetHistory />,
        },
        {
          parentKey: "betHistory",
          key: "betHistoryCashedOut",
          label: t("Cashed Out"),
          component: <BetHistory />,
        },
        {
          parentKey: "betHistory",
          key: "betHistoryWon",
          label: t("Won"),
          component: <BetHistory />,
        },
        {
          parentKey: "betHistory",
          key: "betHistoryLost",
          label: t("Lost"),
          component: <BetHistory />,
        },
        {
          parentKey: "betHistory",
          key: "betHistoryWonReturn",
          label: t("Won Return"),
          component: <BetHistory />,
        },
        {
          parentKey: "betHistory",
          key: "betHistoryLostREturn",
          label: t("Lost Return"),
          component: <BetHistory />,
        },
      ],
    },
    // {
    //   key: "stakeAndEarn",
    //   label: "Stake and Earn",
    //   icon: <GiAlliedStar />,
    //   child: [
    //     {
    //       parentKey: "stakeAndEarn",
    //       key: "stakeAndEarn",
    //       label: "State FTN",
    //       component: "stakeAndEarnStakeFTNComponent",
    //     },
    //     {
    //       parentKey: "stakeAndEarn",
    //       key: "stakeAndEarnWithdrawals",
    //       label: "Withdrawals",
    //       component: "stakeAndEarnWithdrawalsComponent",
    //     },
    //     {
    //       parentKey: "stakeAndEarn",
    //       key: "stakeAndEarnRewards",
    //       label: "Rewards",
    //       component: "StakeAndEarnRewardsComponent",
    //     },
    //   ],
    // },
    {
      key: "bonuses",
      label: t("Bonuses"),
      icon: "bc-i-promotion",
      child: [
        {
          parentKey: "bonuses",
          key: "bonuses",
          label: t("Sport Bonus"),
          component: <SportsBonuses />,
        },
        {
          parentKey: "bonuses",
          key: "casinoBonus",
          label: t("Casino Bonus"),
          component: <CasinoBonus />,
        },
        {
          parentKey: "bonuses",
          key: "casinoFreeSpin",
          label: t("Casino Free Spin"),
          component: <CasinoFreeSpins />,
        },
        {
          parentKey: "bonuses",
          key: "bonusHistory",
          label: t("Bonus History"),
          component: <BonusHistory />,
        },
        {
          parentKey: "bonuses",
          key: "referAFriend",
          label: t("Refer a friend"),
          component: <ReferAFriend />,
        },
        // {
        //   parentKey: "bonuses",
        //   key: "loyaltyPoints",
        //   label: "Loyalty Points",
        //   component: "LoyaltyPointsComponent",
        // },
        {
          parentKey: "bonuses",
          key: "promoCode",
          label: t("Promo code"),
          component: <PromoCode />,
        },
      ],
    },
    {
      key: "balanceManagementDeposit",
      label: t("Balance Management"),
      icon: "bc-i-balance-management",
      child: [
        {
          parentKey: "balanceManagementDeposit",
          key: "balanceManagementDeposit",
          label: t("deposit"),
          icon: "bc-i-circle-dollar",
          component: <Deposit />,
        },
        {
          parentKey: "balanceManagementDeposit",
          key: "balanceManagementWithdraw",
          label: t("withdraw"),
          icon: "bc-i-withdraw",
          component: <Withdraw />,
        },
        {
          parentKey: "balanceManagementDeposit",
          key: "balanceManagementTransactionHistory",
          label: t("Transaction History"),
          icon: "bc-i-history",
          component: <TransactionHistory />,
        },
        {
          parentKey: "balanceManagementDeposit",
          key: "balanceManagementWithdrawStatus",
          label: t("Withdraw Status"),
          icon: "bc-i-withdraws",
          component: <WithdrawStatus />,
        },
      ],
    },
    // {
    //   key: "messages",
    //   label: "Message",
    //   title: "Inbox",
    //   icon: "bc-i-message",
    //   component: "MessagesComponent",
    // },
    // {
    //   key: "rewards",
    //   label: "Rewards",
    //   icon: <SlBadge />,
    //   component: "RewardsComponent",
    // },
  ];
};
